import { TableBody } from 'components/table/TableBody';
import { TableCellDataOrEmpty } from 'components/table/TableCellDataOrEmpty';
import { TableCellLinkOrEmpty } from 'components/table/TableCellLinkOrEmpty';
import { TableColumnVisibility } from 'components/table/TableColumnVisibility';
import { TableConstants } from 'components/table/TableConstants';
import { TableContent } from 'components/table/TableContent';
import { TableData } from 'components/table/TableData';
import * as TableEmptyPrimitive from 'components/table/TableEmpty';
import { TableFilters } from 'components/table/TableFilters';
import { TableFiltersBar } from 'components/table/TableFiltersBar';
import { TableHeader } from 'components/table/TableHeader';
import { TableHeaderCheckbox } from 'components/table/TableHeaderCheckbox';
import { TableHeaderData } from 'components/table/TableHeaderData';
import { TableHeaderSort } from 'components/table/TableHeaderSort';
import * as TablePagination from 'components/table/TablePagination';
import { TableReset } from 'components/table/TableReset';
import { TableResultsCount } from 'components/table/TableResultsCount';
import { TableRoot } from 'components/table/TableRoot';
import { TableRow } from 'components/table/TableRow';
import { TableRowCheckbox } from 'components/table/TableRowCheckbox';
import { TableRowDropdownTrigger } from 'components/table/TableRowDropdownTrigger';
import { TableRowExpand } from 'components/table/TableRowExpand';
import { TableRowRadioInput } from 'components/table/TableRowRadioInput';
import { TableSkeleton, TableSkeletonRoot } from 'components/table/TableSkeleton';
import { TableToggleFullWidth } from 'components/table/TableToggleFullWidth';

const Table = TableRoot;
const Root = TableRoot;
const Content = TableContent;
const Header = TableHeader;
const HeaderData = TableHeaderData;
const HeaderSort = TableHeaderSort;
const ColumnVisibility = TableColumnVisibility;
const Filters = TableFilters;
const FiltersBar = TableFiltersBar;
const HeaderCheckbox = TableHeaderCheckbox;
const ResultsCount = TableResultsCount;
const Body = TableBody;
const Row = TableRow;
const RowCheckbox = TableRowCheckbox;
const RowRadioInput = TableRowRadioInput;
const RowDropdownTrigger = TableRowDropdownTrigger;
const RowExpand = TableRowExpand;
const ToggleFullWidth = TableToggleFullWidth;
const Reset = TableReset;
const Data = TableData;
const Skeleton = TableSkeleton;
const SkeletonRoot = TableSkeletonRoot;
const CellDataOrEmpty = TableCellDataOrEmpty;
const CellLinkOrEmpty = TableCellLinkOrEmpty;
const Constants = TableConstants;

// re-alias TableEmpty parts
const TableEmpty = TableEmptyPrimitive.Empty;
const TableEmptyIcon = TableEmptyPrimitive.EmptyIcon;
const TableEmptyTitle = TableEmptyPrimitive.EmptyTitle;
const TableEmptyDescription = TableEmptyPrimitive.EmptyDescription;
const TableEmptyWhenNotSearching = TableEmptyPrimitive.EmptyWhenNotSearching;

const Empty = TableEmpty;
const EmptyIcon = TableEmptyIcon;
const EmptyTitle = TableEmptyTitle;
const EmptyDescription = TableEmptyDescription;
const EmptyWhenNotSearching = TableEmptyWhenNotSearching;

// re-alias TablePagination parts
const TablePaginationRoot = TablePagination.Root;
const TablePaginationPageNavigation = TablePagination.PageNavigation;
const TablePaginationPerPageDropdown = TablePagination.PerPageDropdown;

const Pagination = TablePaginationRoot;
const PaginationPageNavigation = TablePaginationPageNavigation;
const PaginationPerPageDropdown = TablePaginationPerPageDropdown;

export {
    Table,
    TableContent,
    TableHeader,
    TableHeaderData,
    TableHeaderSort,
    TableHeaderCheckbox,
    TableBody,
    TableRow,
    TableData,
    TableCellDataOrEmpty,
    TableCellLinkOrEmpty,
    TableRowCheckbox,
    TableRowRadioInput,
    TableRowDropdownTrigger,
    TableRowExpand,
    TableColumnVisibility,
    TableFilters,
    TableFiltersBar,
    TableToggleFullWidth,
    TableReset,
    TableEmpty,
    TableEmptyIcon,
    TableEmptyTitle,
    TableEmptyDescription,
    TableEmptyWhenNotSearching,
    TablePaginationRoot,
    TableSkeleton,
    TablePaginationPageNavigation,
    TablePaginationPerPageDropdown,
    TableConstants,
    TableResultsCount,
    //
    Root,
    Content,
    Header,
    HeaderSort,
    HeaderData,
    HeaderCheckbox,
    Body,
    Row,
    Data,
    CellDataOrEmpty,
    CellLinkOrEmpty,
    RowDropdownTrigger,
    RowExpand,
    RowCheckbox,
    RowRadioInput,
    ColumnVisibility,
    Filters,
    FiltersBar,
    ToggleFullWidth,
    Reset,
    Empty,
    EmptyIcon,
    EmptyTitle,
    EmptyDescription,
    EmptyWhenNotSearching,
    SkeletonRoot,
    Skeleton,
    Pagination,
    PaginationPageNavigation,
    PaginationPerPageDropdown,
    Constants,
    ResultsCount,
};
